// What a page shows when the signed-in role may not open it (also when the URL is typed by hand).
import { EmptyState } from '@the-kit/ui'
import { Lock } from 'lucide-react'

export function NoAccess() {
  return (
    <div data-testid="no-access">
      <EmptyState
        icon={Lock}
        title="No access"
        description="Your role cannot open this page. The API refuses it too, not only the screen."
      />
    </div>
  )
}
